import {nextTick} from 'vue';
import Blazy from 'blazy';
import {globalActions} from '../../store/global-actions';
import {store} from '../../store/global-store';
import {googleAnalyticMixin} from '../mixins/component-mixins';

const actionableCard = {
    data() {
        return {
            forceFocus: false,
            primaryAction: null,
        };
    },
    computed: {
        primaryActionComponentName() {
            return `${this.primaryAction.actionName}-primary-action`;
        },
    },
    methods: {
        setPrimaryAction(action) {
            this.primaryAction = action;
            nextTick(() => {
                this.forceFocus = true;
                nextTick(() => this.forceFocus = false);
            });
        },
        hidePrimaryAction() {
            this.setPrimaryAction(null);
        },
    },
};

function initListingCardComponent(app) {
    const listingCardBase = {
        props: {
            listing: {
                required: true,
            },
            sortIndex: {
                type: Number,
                required: false,
                default: 0,
            },
            favoriteUrl: {
                type: String,
                required: false,
            },
            previewUrl: {
                type: String,
                required: false,
            },
            loadPhoneUrl: {
                type: String,
                required: false,
            },
            detailsUrl: {
                type: String,
                required: false,
            },
            recommendedAdvertsUrl: {
                type: String,
                required: false,
            },
            forceThumbnailForLazy: {
                type: Boolean,
                required: false,
                default: true,
            },
            showContactButton: {
                type: Boolean,
                required: false,
                default: false,
            },
            thumbnailForLazy: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                isListingVisible: this.listing.visible,
                showThumbnailForLazy: this.forceThumbnailForLazy,
            };
        },
        computed: {
            thumbImageUrl() {
                if (!this.coverPhoto) {
                    return this.thumbnailForLazy;
                }

                return this.showThumbnailForLazy ? this.coverPhoto.thumbnailHRef : (this.thumbnailForLazy || this.sampleImageUrl);
            },
            sampleImageUrl() {
                return this.coverPhoto.sampleHRef || this.coverPhoto.thumbnailHRef || this.coverPhoto.hRef;
            },
            priceText() {
                return (!this.listing.hidePrice && this.listing.priceText) ? this.listing.priceText : this.listing.priceTypeText;
            },
            priceAreaAddon() {
                return this.listing.priceAreaAddon;
            },
            showFloor() {
                return this.listing.floorText && !this.listing.bedroomsNumberText && !this.listing.bathroomsNumberText;
            },
            highlightImageText() {
                return this.listing.isRecentlyDealCompleted || !this.isListingVisible;
            },
            coverPhoto() {
                return this.listing && this.listing.media && this.listing.media.coverPhoto;
            },
        },
        methods: {
            _subscribeCoverImgLoaded() {
                // Probably it's not ideal but this solution solve multiple initializing blazy when
                // there are some changes for listing card element (e.g. sortIndex).
                // Once thumbnail was successfully loaded we don't try to use sample anymore.
                const that = this;
                // eslint-disable-next-line no-unused-vars
                const bLazy = new Blazy({ // NOSONAR
                    success: (el) => {
                        if (el.dataset.src === that.coverPhoto.thumbnailHRef) {
                            that.showThumbnailForLazy = true;
                        }
                    },
                });
            },
        },
        mounted() {
            if (this.coverPhoto) {
                this._subscribeCoverImgLoaded();
            }
        },
    };

    app.component('listing-card', {
        extends: listingCardBase,
        template: '#listing-card',
        mixins: [googleAnalyticMixin],
        props: {
            isAuthenticated: {
                type: Boolean,
                default: false,
            },
            isClickable: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            fullRecommendedAdvertsUrl() {
                return `${this.recommendedAdvertsUrl}?advertId=${this.listing.id}`;
            },
            isViewed() {
                return this.isAuthenticated && this.listing.isViewed;
            },
        },
        methods: {
            async preview() {
                if (this.isClickable) {
                    this._markViewed();
                    globalActions.openPreview(this.listing.id, this.listing.listingType, this.previewUrl);
                }
            },
            _markViewed() {
                if (this.isAuthenticated && this.favoriteUrl) {
                    this.listing.isViewed = true;
                }
            },
            _subscribeMarkAsViewedStore() {
                store.subscribe((mutation) => {
                    if (mutation.type === 'markAsViewed' && mutation.payload === this.listing.id) {
                        this._markViewed();
                    }
                });
            },
        },
        mounted() {
            this._subscribeMarkAsViewedStore();
        },
    });

    app.component('listing-card-extended', {
        extends: listingCardBase,
        template: '#listing-card-extended',
        mixins: [actionableCard],
        props: {
            isMobileDevice: {type: Boolean, required: false},
            starInfo: {required: false},
            shareText: {type: String, required: false},
            shareUrl: {type: String, required: false},
            shareTrackUrl: {type: String, required: false},
            isAdvert: {type: Boolean, default: true},
        },
        data() {
            return {
                isListingFavorite: true,
                isMobile: this.isMobileDevice,
            };
        },
        methods: {
            preview() {
                if (this.listing.allRequiredFilled) {
                    globalActions.openFullscreenModal(this.detailsUrl, this.isAdvert, this.previewUrl);
                } else {
                    location.href = this.previewUrl;
                }
            },
            change(value) {
                if (value && value.actionName === 'show') {
                    this.isListingVisible = value.state;
                    if (!this.isListingVisible) {
                        this.listing.engageAction = null;
                    }

                    this.$refs.moreActionsDropdown.close();
                }

                this.$emit('update', value, this.listing.id);
            },
            hasActions() {
                return (this.listing.actions && this.listing.actions.length) ||
                    (this.listing.moreActions && this.listing.moreActions.length);
            },
        },
    });
}

export {
    initListingCardComponent,
    actionableCard,
};
